import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Footer from "./components/Footer";

ReactDOM.render(
  <>
    <App />
    <Footer />
  </>,
  document.getElementById("root")
);
